const { smartId } = require('../../tools')
const { getUnknownBatchID } = require('./virtual-batch')

const linesToCounts = (lines) => {
  const counts = {}
  lines.forEach(line => {
    const { sku, amount } = line
    const batchId = getUnknownBatchID(`product:${sku}`)
    counts[batchId] = {
      quantity: amount
    }
  })
  return counts
}

/**
 * Parse JSONB field from Postgres - handles both string and object formats
 */
const parseJsonField = (value) => {
  if (!value) {
    return undefined
  }
  if (typeof value === 'string') {
    try {
      return JSON.parse(value)
    } catch (e) {
      return undefined
    }
  }
  return value
}

const fromRelationalModel = (data) => {
  const { shipment, lines = data.shipment && data.shipment.lines } = data
  const { shipmentNo } = smartId.parse(shipment.shipment_id)
  const snapshotId = `${shipment.shipment_id}:status:${shipment.status}:`

  // Parse JSONB fields from Postgres
  const snapshotDates = parseJsonField(shipment.snapshot_dates)

  // Parse history from Postgres if available
  const history = parseJsonField(shipment.history) || {}

  const record = {
    shipmentNo,
    id: shipment.shipment_id,
    snapshotId,
    status: shipment.status,
    planningType: shipment.planning_type,
    origin: { id: shipment.origin_id },
    destination: { id: shipment.destination_id },
    orderId: shipment.order_id,
    createdAt: shipment.created_at,
    createdBy: { user: shipment.created_by },
    updatedAt: shipment.updated_at,
    updatedBy: { user: shipment.updated_by },
    comments: shipment.notes ? shipment.notes.split(';').map(comment => {
      const [createdAt, createdBy, commentText] = comment.split(', ')
      return { createdAt, createdBy: { user: createdBy }, comment: commentText }
    }) : [],
    counts: lines ? linesToCounts(lines) : {},
    history,
    funder: { id: shipment.funder_id },
    route: {
      id: shipment.route_id,
      name: shipment.route_name
    },
    programId: shipment.program_id,
    carrierName: shipment.carrier_name,
    snapshotDates,
    driverName: shipment.driver_name
  }

  // GPS + OTP fields are projected by the LMD download SQL (issue 24913) so
  // the client-side "unverified" filter has what it needs without a second
  // enrichment query. Non-download queries do not project these columns; the
  // typeof / existence checks keep the fields off records that lack them.
  if (typeof shipment.is_gps_authenticated === 'boolean') {
    record.isGpsAuthenticated = shipment.is_gps_authenticated
  }
  const gpsValidationFailComment = parseJsonField(shipment.gps_validation_fail_comment)
  if (gpsValidationFailComment) {
    record.gpsValidationFailComment = gpsValidationFailComment
  }
  // Only build otp when the LEFT JOIN actually matched a shipment_otp row.
  // Without this guard, a missing OTP record would produce
  // { hasKeyAndPassword: false } and every OTP-less shipment would look
  // unverified. hasKeyAndPassword is precomputed in SQL so the plaintext
  // password never leaves Postgres; the encryption key is not projected
  // either because the download filter does not read it.
  if (shipment.otp_shipment_id) {
    record.otp = { hasKeyAndPassword: !!shipment.otp_has_key_and_password }
    if (shipment.otp_user_fail_reason) {
      record.otp.userFailReason = shipment.otp_user_fail_reason
    }
  }

  return record
}

module.exports = { fromRelationalModel }
